import { typedObjectEntries } from '../utils/typedObjectEntries'
import { typedReduce } from '../utils/typedReduce'
import { IUser, UserRights, UserRightType } from '../../../entities/User'

type ValueOf<T> = T[keyof T]

export const mapRightsNullToNoPermission = (user: IUser): IUser => {
	const rights: UserRights = {
		users: UserRightType.NO_PERMISSION,
		clients: UserRightType.NO_PERMISSION,
		products: UserRightType.NO_PERMISSION,
		licenses: UserRightType.NO_PERMISSION,
		instances: UserRightType.NO_PERMISSION,
		applications: UserRightType.NO_PERMISSION,
		externalServices: UserRightType.NO_PERMISSION,
		adminActions: UserRightType.NO_PERMISSION
	}

	user.rights = typedReduce(
		// @ts-ignore
		typedObjectEntries(user.rights),
		(acc: UserRights, [k, v]: [keyof UserRights, ValueOf<UserRights>]) => {
			return { ...acc, [k]: v }
		},
		rights
	)

	return user
}

export const mapAppRightsNullToNoPermission = (appRights: UserRights) => {
	const rights = {
		clients: UserRightType.NO_PERMISSION,
		products: UserRightType.NO_PERMISSION,
		licenses: UserRightType.NO_PERMISSION,
		instances: UserRightType.NO_PERMISSION,
		users: UserRightType.NO_PERMISSION
	}

	return typedReduce(
		// @ts-ignore
		typedObjectEntries(appRights),
		(acc: UserRights, [k, v]: [keyof UserRights, ValueOf<UserRights>]) => {
			return { ...acc, [k]: v }
		},
		rights
	)
}
